import './App.css';
import TextBox from './components/TextBox';
import React from 'react'
import AddTodo from './components/AddTodo';
import AllTodos from './components/AllTodos';

function App() {
	const [content, setContent] = React.useState([])
	const [todo, setTodo] = React.useState([]);
	const [allTodos, setAllTodos] = React.useState([]);
	const [status, setStatus] = React.useState('all');
	const [filteredTodos, setFilteredTodos] = React.useState([]);
	const [time, setTime] = React.useState(new Date())

	React.useEffect(() => {
		getContentFromLocal();
		getTodosFromLocal()
		var timer = setInterval(() =>setTime(new Date()), 1000)
		return function cleanup() {
			clearInterval(timer)
		}
	}, [])

	React.useEffect(() => {
		saveContentToLocal();
		saveTodosToLocal();
		filterHandler();
	}, [content, allTodos, status])


  const saveContentToLocal = () => {
    localStorage.setItem('content', JSON.stringify(content))
  }

  const getContentFromLocal = () => {
    if (localStorage.getItem('content') === null) {
      localStorage.setItem('content', JSON.stringify([]))
    } else {
      let localContent = JSON.parse(localStorage.getItem('content'))
      setContent(localContent)
    }
  }

  const saveTodosToLocal = () => {
		localStorage.setItem('todo-items', JSON.stringify(allTodos));
	};

	const getTodosFromLocal = () => {
		if (localStorage.getItem('todo-items') === null) {
			localStorage.setItem('todo-items', JSON.stringify([]));
			console.log('nothing in local storage');
		} else {
			let localTodos = JSON.parse(localStorage.getItem('todo-items'));
			setAllTodos(localTodos);
		}
	};

  const filterHandler = () => {
		switch (status) {
			case 'completed':
				setFilteredTodos(allTodos.filter((todo) => todo.completed === true));
				break;
			case 'incomplete':
				setFilteredTodos(allTodos.filter((todo) => todo.completed === false));
				break;
			default:
				setFilteredTodos(allTodos);
				break;
		}
	};

	
  return (
		<div className='App'>
			<div className='text-area-box'>
				<TextBox content={content} setContent={setContent} />
				<div className='time'>
					{time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
				</div>
			</div>

			<div className='todo-list'>
				<h1>To-Dos</h1>
				<hr />
				<AddTodo
					todo={todo}
					setTodo={setTodo}
					allTodos={allTodos}
					setAllTodos={setAllTodos}
					setStatus={setStatus}
				/>
				<hr />
				<AllTodos
					allTodos={allTodos}
					setAllTodos={setAllTodos}
					filteredTodos={filteredTodos}
				/>
			</div>
		</div>
	);
}

export default App;
